export const noticeMessages = {
  0: [
    "로고 이미지가 등록되지 않은 경우 **회사명**이 대신 노출됩니다.",
    "퀵 메뉴는 최대 **3개까지** 설정할 수 있습니다.",
  ],
  1: [],
  2: [],
  3: [],
};
